// Get the modal
var modal = document.getElementById("pdpDetailModal");

// Get the button that opens the modal
var pdpDetailBtn = document.getElementById("pdpDetailBtn");

// Get the <span> element that closes the modal
var pdpDetailModalClose = document.getElementsByClassName(
  "pdpDetailModal-close"
)[0];

// When the user clicks the button, open the modal
if (pdpDetailBtn && modal) {
  pdpDetailBtn.onclick = function () {
    modal.style.display = "flex";
  };
}

// When the user clicks on <span> (x), close the modal
if (pdpDetailModalClose && modal) {
  pdpDetailModalClose.onclick = function () {
    modal.style.display = "none";
  };
}

// When the user clicks anywhere outside of the modal, close it
if (modal) {
  window.onclick = function (event) {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  };
}
// Updates compare-at price and per-bottle price based on current
// variant and Skio subscription toggle state.
function updatePriceDisplay() {
  var productForm = document.querySelector('.product__form[data-product-form]');
  if (!productForm) return;

  var masterSelect = productForm.querySelector('.master_selection');
  if (!masterSelect) return;

  var selectedOption = masterSelect.options[masterSelect.selectedIndex];
  if (!selectedOption) return;

  var isSubscribeSelected = document.querySelector(
    '.skio-group-container--subscribe.skio-group-container--selected'
  );

  // Update compare-at price
  var compareEl = document.querySelector('.product__price-and-badge [data-compare-price]');
  var variantInput = productForm.querySelector('input[name="id"][data-productid]');
  var productJsonEl = document.querySelector('[data-product-json]');
  if (compareEl && variantInput && productJsonEl) {
    var prod = JSON.parse(productJsonEl.textContent);
    var found = prod.variants && prod.variants.find(function(v) {
      return v.id === parseInt(variantInput.value);
    });
    if (found) {
      if (isSubscribeSelected) {
        compareEl.innerHTML = '<span class="money">$' + (found.price / 100).toFixed(2) + '</span>';
        compareEl.classList.remove('hidden');
      } else {
        if (found.compare_at_price && found.compare_at_price > found.price) {
          compareEl.innerHTML = '<span class="money">$' + (found.compare_at_price / 100).toFixed(2) + '</span>';
          compareEl.classList.remove('hidden');
        } else {
          compareEl.innerHTML = '';
          compareEl.classList.add('hidden');
        }
      }
    }
  }

  // Update per-bottle price
  var perBottlePrice = isSubscribeSelected
    ? $(selectedOption).data('per-bottle-subscription-price')
    : $(selectedOption).data('per-bottle-price');

  if (perBottlePrice) {
    $('.per_bottle_price').remove();
    $('.product__price-and-badge .product__price[data-price-wrapper]').append(
      '<span class="per_bottle_price">(' + perBottlePrice + ' / bottle)</span>'
    );
  }
}

(function() {
  function startObserving() {
    var skioContainer = document.querySelector('.selector-wrapper--qty');
    if (!skioContainer) return;

    var debounceTimer = null;

    var observer = new MutationObserver(function() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(updatePriceDisplay, 50);
    });

    observer.observe(skioContainer, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true
    });

    updatePriceDisplay();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserving);
  } else {
    startObserving();
  }
})();